import React from 'react';
import classnames from 'classnames';

import { Form } from 'core/forms';
import i18n from 'i18next';

import { Loading } from 'uikit/loaders';

import InitiativeFormActions from './initiativeFormActions';

import styles from '../styles/newAudienceForm.module.scss';

const NewAudienceForm = ({
  hasError,
  hasSubmitted,
  isSubmitting,
  model,
  onCancel,
  onLoad,
  onSubmit,
  onUpdate,
  schema,
}) => (
  <div className={classnames(hasSubmitted && styles.hasSubmitted)}>
    <Form
      model={model}
      onLoad={onLoad}
      onUpdate={onUpdate}
      schema={schema}
    />
    {isSubmitting ? <Loading className={styles.loader} /> : (
      <InitiativeFormActions
        isSubmitDisabled={hasError}
        onCancel={onCancel}
        onSubmit={onSubmit}
        submitText={i18n.t('save-audience')}
      />
    )}
  </div>
);

export default React.memo(NewAudienceForm);
